import { Box, Button, Link, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

// Static re-usable page for when we are redirected back to the website - like after Stripe onboarding

export default function ExternalRedirectPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const deepLink = params.get('deepLink');
  const success = params.get('success');

  const title =
    success && [true, 'true'].includes(success)
      ? 'Success!'
      : 'Something went wrong';

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
      }}>
      <Link href="/">
        <img src="/Logo.svg" alt="Porter logo" />
      </Link>
      <Typography variant="h1">{title}</Typography>
      <Typography variant="body2">
        You can close this window and return to the app.
      </Typography>
      {deepLink && (
        <Button
          variant="contained"
          color="primary"
          href={deepLink}
          target="_blank">
          Return to app
        </Button>
      )}
    </Box>
  );
}
